module.exports = "<a href=\"javascript:;\" <% isActive ? print('class=\"is-active\"') : ''; %>><% print(Name); %></a>"